var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaEnkeltActiveHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.638,
    height: 22.16,
    viewBox: "0 0 23.638 22.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shop",
    d: "M4.388,1.517A1.477,1.477,0,0,1,5.511,1H18.127a1.477,1.477,0,0,1,1.123.517l3.854,4.5a2.216,2.216,0,0,1,.533,1.442v.377a3.509,3.509,0,0,1-6.279,2.154,3.509,3.509,0,0,1-5.54,0,3.509,3.509,0,0,1-5.54,0A3.509,3.509,0,0,1,0,7.833V7.456A2.216,2.216,0,0,1,.533,6.014l3.856-4.5ZM2.216,12.08a.739.739,0,0,1,.739.739v8.864H4.432V14.3a1.477,1.477,0,0,1,1.477-1.477h4.432A1.477,1.477,0,0,1,11.819,14.3v7.387h8.864V12.819a.739.739,0,0,1,1.477,0v8.864H22.9a.739.739,0,0,1,0,1.477H.739a.739.739,0,1,1,0-1.477h.739V12.819A.739.739,0,0,1,2.216,12.08Zm3.693,9.6h4.432V14.3H5.909ZM13.3,14.3a1.477,1.477,0,0,1,1.477-1.477h2.955A1.477,1.477,0,0,1,19.206,14.3v4.432a1.477,1.477,0,0,1-1.477,1.477H14.774A1.477,1.477,0,0,1,13.3,18.728Zm4.432,0H14.774v4.432h2.955Z",
    transform: "translate(0 -1)",
    fill: "#222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaEnkeltActiveHome);
export default __webpack_public_path__ + "static/media/sa-enkelt-active-home.e8d6aa4b6e1004113e456d535feccd0a.svg";
export { ForwardRef as ReactComponent };